import React from "react";
// import getPortalLocData from '../config/loc';

const currentYear = new Date().getFullYear();

const Footer = () => (


    <footer id="footer">
        <div className="footer-top">
            <div className="container">
                <div className="row gy-3">
                    <div className="col-lg-3 col-md-3 col-sm-6 footer-links">
                        <h4>Information</h4>
                        <ul className="">
                            <li><a href="/about-us">About Us</a></li>
                            {/* <li><a href="/faq">Frequently asked questions</a></li> */}
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 footer-links">
                        <h4>Policies</h4>
                        <ul className="">
                            <li><a href="/terms">Terms and conditions</a></li>
                            <li><a href="/privacy-policy">Privacy policy</a></li>
                            <li><a href="/refund-policy">Refund policy</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 footer-links">
                        <h4 className="">Get in touch</h4>
                        <ul className="">
                            <li><i className="fa fa-envelope footer-ico"></i>
                                <div className="d-flex flex-column width_80_percent">
                                    <a href="mailto:info@longtermparking.ie">info@longtermparking.ie</a>
                                </div>
                            </li>
                            <li className="d-flex align-items-baseline"><i className="fa fa-map-marker footer-ico"></i>
                                <div className="d-flex flex-column width_80_percent">
                                    <span>Dublin, Ireland</span>
                                </div>
                            </li>
                        </ul>
                        {/* <div className="email-wrapper pe-3">
                            <input type="email" id="sEmail" placeholder="Email" className="form-control mt-2" required=""/>
                            <button className="btn footer_subscribe_btn mt-2 mb-2" onclick="subscribeNow()">Subscribe Now</button>
                        </div> */}
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div className="social-networks">
                            <h4>Pay with us</h4>
                            <div className="payment_wrap">
                                <img src="/images/airport/stripe.png" alt="Stripe" title="Stripe" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="footer-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 d-lg-none">
                        <div className="social-links">
                            <p className="m-0 text-white">Follow us on - </p>
                            <a target="_blank" title="Facebook" href="https://www.facebook.com/">
                                <i className="fa fa-facebook-f bxl-facebook"></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="copyright text-center">
                            {currentYear} &copy; <a href="/"><strong>LongTermParking</strong></a> - All rights reserved.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="text-center">
                            Powered by Easytrip
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
); 


export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx